module.exports = __webpack_public_path__ + "static/default-avatar-image-1f1541eb6dbb43e097bc29c262bbfb89.png";